module.exports = __webpack_public_path__ + "media/ט.2c24e02a.mp3";